import { createFeature, createReducer, on } from '@ngrx/store';
import { Statistic } from '@main/customers/store/statistic';
import { customerStatisticsApiActions } from '@main/customers/store/customer-statistics-api.actions';

interface State {
  sumOfJobAmountsByCalendarYearAndCustomerId: {
    [customerId: number]: Statistic[];
  }
}

const initialState: State = {
  sumOfJobAmountsByCalendarYearAndCustomerId: {}
};

export const customerStatisticsFeature = createFeature({
  name: 'CustomerStatistics',
  reducer: createReducer(
    initialState,
    on(customerStatisticsApiActions.getStatisticsSuccess, (state, { customerId, statistics }): State => ({
      ...state,
      sumOfJobAmountsByCalendarYearAndCustomerId: {
        ...state.sumOfJobAmountsByCalendarYearAndCustomerId,
        [customerId]: statistics,
      },
    })),
  ),
});
